import React, { Component } from "react";
import { translate } from "react-i18next";
import { Divider } from "semantic-ui-react";
import { COLORS, URL } from "Constants";

class Footer extends Component {
  render() {
    const { t } = this.props;

    return (
      <footer id="footer">
        <Divider id="footer-divider" />
        <div id="footer-content">
          <span style={{ color: COLORS.POLY_SLATE }}>
            {t("Footer.copyright")}
          </span>
          {t("Separators.vertical")}
          <span>
            <a
              href={URL.POLY_LICENSE_AGREEMENT_URL}
              style={{ color: COLORS.POLY_MIDNIGHT }}
              target="_blank"
              rel="noopener noreferrer"
              id="FooterToS"
            >
              {t("Footer.tos")}
            </a>
            {t("Separators.vertical")}
            <a
              href={URL.POLY_PRIVACY_URL}
              style={{ color: COLORS.POLY_MIDNIGHT }}
              target="_blank"
              rel="noopener noreferrer"
              id="FooterPrivacyPolicy"
            >
              {t("Footer.privacy")}
            </a>
          </span>
        </div>
      </footer>
    );
  }
}

export default translate()(Footer);
